export default __webpack_public_path__ + "static/media/FDMBasicImg.5519b386.jpg";